export default __webpack_public_path__ + "static/media/mac.9a464476.svg";